export const gcpMachineImagePaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/machine-images`,
  detail: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/machine-images/${encodeURIComponent(name)}`,
  create: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/machine-images`,
  update: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/machine-images/${encodeURIComponent(name)}`,
  remove: (connectionId, name) =>
    `/compute/cloud-account-connections/${connectionId}/gcp/machine-images/${encodeURIComponent(name)}`,
};
